import type { AxiosResponse } from 'axios';
import type {
  CreateWebhookT,
  DeliveryStatusItemT,
  EventLogT,
  Subscription,
  UpdateWebhookT,
} from 'lib-shared-legacy-types';

import { ajaxSend, ApiErrorStatusCode } from '../../../api/api';

const basePath = '/v1/webhooks';

type ErrorResponse = { errors: string[] };

export function getSubscription(
  id: string,
): Promise<AxiosResponse<Subscription>> {
  return ajaxSend({
    path: `${basePath}/subscriptions/${id}`,
  });
}

export function getSubscriptions(): Promise<
  AxiosResponse<{ subscriptions: Subscription[] }>
> {
  return ajaxSend({
    path: `${basePath}/subscriptions`,
  });
}

export function getEvents(): Promise<AxiosResponse<{ fqns: string[] }>> {
  return ajaxSend({
    path: `${basePath}/fqns`,
  });
}

export function addSubscription({
  name,
  fqns,
  url,
  user_supplied_headers,
  is_enabled,
}: CreateWebhookT): Promise<{ data: Subscription } | ErrorResponse> {
  return ajaxSend({
    method: 'POST',
    path: `${basePath}/subscriptions`,
    data: {
      name,
      fqns,
      url,
      user_supplied_headers,
      is_enabled,
    },
    ignoreErrorCodes: [ApiErrorStatusCode.Conflict],
  });
}

export function deleteSubscription(
  id: string,
): Promise<AxiosResponse<Subscription>> {
  return ajaxSend({
    method: 'DELETE',
    path: `${basePath}/subscriptions/${id}`,
  });
}

export function updateSubscription({
  id,
  name,
  fqns,
  url,
  user_supplied_headers,
  is_enabled,
}: UpdateWebhookT): Promise<{ data: Subscription } | ErrorResponse> {
  return ajaxSend({
    method: 'PATCH',
    path: `${basePath}/subscriptions/${id}`,
    data: {
      name,
      fqns,
      url,
      user_supplied_headers,
      is_enabled,
    },
    ignoreErrorCodes: [ApiErrorStatusCode.Conflict],
  });
}

export function getEventLog(payload: {
  id: string;
  event: string;
}): Promise<AxiosResponse<{ events: EventLogT[] }>> {
  const { id, event } = payload;

  return ajaxSend({
    path: `${basePath}/delivery_events/${id}/${event}`,
  });
}

export function getDeliveryStatus(
  id: string,
): Promise<AxiosResponse<{ delivery_statuses: DeliveryStatusItemT[] }>> {
  return ajaxSend({
    path: `${basePath}/delivery_statuses/${id}`,
  });
}
